import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Order/OrderOverview/orderOverview.container"
    ).then((module) => ({
        default: module.OrderOverview
    }))
);
